<app-dialog  *ngIf="!data.isTags"
  [title]="data?.title"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    {
      text: 'Save',
      spin: spin,
      isDisabled: form.valid ? false : true
    }
  ]"
  (action)="action($event)"
  (close)="close()"
>
  <div class="form" [formGroup]="form">
    <div class="input-container" *ngIf="!data.isProductTag">
      <label class="input-container_label">Tag name</label>
      <input type="text" formControlName="name" class="input-container_input" />
    </div>
    <div class="input-container"*ngIf="!data.isProductTag">
      <label class="input-container_label">Color</label>
      <div class="input-container_wrapper">
        <input class="input-container_input input-container_input--number" formControlName="colorCode"/>
      <span 
      class="input-container_icon input-container_colorPicker"
      [(colorPicker)]="color"
      (colorPickerOpen)="onEventLog('colorPickerOpen', $event)"
      (colorPickerClose)="onEventLog('colorPickerClose', $event)"
      (cpInputChange)="onEventLog('cpInputChange', $event)"
      (cpSliderDragStart)="onEventLog('cpSliderDragStart', $event)"
      (cpSliderDragEnd)="onEventLog('cpSliderDragEnd', $event)">
        <svg width="14.12" height="14.19"><use xlink:href="assets/images/sprite-icons.svg#color-picker-icon"></use></svg>
      </span>
      <span [style.backgroundColor]="color " class="input-container_icon input-container_colorResult"></span>
      </div>
    </div>
    <div class="input-container" *ngIf="!data.isProductTag">
      <label class="input-container_label d-block">Tag sample</label>
      <span *ngIf="form.get('name')?.value && form.get('colorCode')?.value"class="indicator-tags_tags" [style.backgroundColor]="color" [matTooltip]="form.get('name')?.value">
         {{ form.get('name')?.value }} 
     </span>
    </div>
  </div>
</app-dialog>
<div class="indicator-tags d-flex flex-column align-items-start" *ngIf="data.isTags &&  data.tag.length">
  <span class="indicator-tags_tags" *ngFor="let tag of data.tag" [style.backgroundColor]="tag?.colorCode" (click)="!data.isShipmentSku ? openTags(tag) : null" >
     {{tag.name}}
  </span>
</div>
<div class="tags-not-found" *ngIf="data.isTags && data.tag.length==0">
  <span> No Tags </span>
</div>
